module.exports = __webpack_public_path__ + "img/TRAINING_IN.bf80978c.svg";